<template>
    <div id="app">
        <div v-if="loading" class="loading-indicator">
            <div class="loading-container" style="display: none;">
                <div class="loading">
                    <img src="/static/images/loading.gif">
                </div>
            </div>
        </div>
        <template v-else>
            <template v-if="$route.path.indexOf('/backend/') >= 0">
                <app-backend-header></app-backend-header>
                <div id="wrapper" class="app-sidebar-right">
                    <app-sidebar></app-sidebar>
                    <router-view></router-view>
                </div>
            </template>
            <template v-else-if="$route.path.indexOf('/login') >= 0">
                <router-view></router-view>
            </template>
            <template v-else>
                <app-header v-if="showHeader"></app-header>
                <router-view></router-view>
                <app-footer></app-footer>
            </template>
        </template>
    </div>
</template>

<script>
import eventBus from './components/event-bus';
import { setAppInstance } from '@/router';
import Header from "@/components/partials/Header.vue";
import Footer from "@/components/partials/Footer.vue";
import Sidebar from "@/components/partials/Sidebar.vue";
import BackendHeader from '@/components/backend/partials/Header';

export default {
    components: {
        'app-header': Header,
        'app-footer': Footer,
        'app-sidebar': Sidebar,
        'app-backend-header': BackendHeader
    },
    data() {
        return {
            loading: true,
            showHeader: true,
        };
    },
    mounted() {
        setAppInstance(this);
        this.checkLoginPage();
    },
    methods: {
        checkLoginPage() {
            this.showHeader = window.location.pathname !== "/login";
            if (!this.showHeader) {
                $(".app-sidebar-right").css({
                    "padding-left": "0px",
                    "margin-top": "0px",
                    "-webkit-transition": "all 0.0s ease",
                    "-moz-transition": "all 0.0s ease",
                    "-o-transition": "all 0.0s ease",
                    "transition": "all 0.0s ease"
                });
            }
        },
    },
}
</script>

<style>
.loading-indicator {
    text-align: center;
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue